import type { Copy } from "../types";

export const mr: Copy = {
    seo: {
      title: "कार वय कॅल्क्युलेटर | वर्ष आणि महिन्यानुसार वाहनाचे वय तपासा",
      description:
        "उत्पादन वर्ष आणि ऐच्छिक महिन्यानुसार वाहनाचे अचूक वय तपासा. वर्ष, महिने, दिवस, एकूण दिवस आणि महत्त्वाचे टप्पे एका स्वच्छ साधनात पहा.",
      keywords: [
        "कार वय कॅल्क्युलेटर",
        "वाहन वय कॅल्क्युलेटर",
        "कार उत्पादन वर्ष तपासा",
        "वाहन उत्पादन महिना तपासा",
        "माझी कार किती जुनी आहे",
        "वर्षानुसार कार वय",
        "वाहन वय तपासा",
        "RC वय कॅल्क्युलेटर",
        "महिन्यानुसार कार वय",
        "वाहन तारीख कॅल्क्युलेटर",
        "mParivahan पर्याय",
        "Parivahan पर्याय",
        "RTO वाहन वय कॅल्क्युलेटर",
        "कार नोंदणी वय",
        "वाहन नोंदणी वय",
      ],
      faq: [
        {
          question: "हे कॅल्क्युलेटर काय करते?",
          answer:
            "हे निवडलेल्या उत्पादन वर्ष आणि ऐच्छिक महिन्यानुसार वाहनाचे अचूक वय मोजते आणि वर्ष, महिने, दिवस आणि महत्त्वाची माहिती दाखवते.",
        },
        {
          question: "ऐच्छिक महिना का आहे?",
          answer:
            "महिना जोडल्याने वयाची गणना अधिक अचूक होते. महिना निवडला नाही तर निवडलेल्या वर्षाचा जानेवारी वापरला जातो.",
        },
        {
          question: "भविष्यातील वर्ष किंवा महिना निवडता येतो का?",
          answer:
            "नाही. भविष्यातील वर्षे रोखली जातात आणि निवडलेले वर्ष चालू वर्ष असल्यास भविष्यातील महिनेही बंद केले जातात.",
        },
      ],
    },
    headerTagline: "वाहन साधन",
    headerTitle: "कार वय कॅल्क्युलेटर",
    reset: "रीसेट",
    switchToLight: "हलका मोड",
    switchToDark: "गडद मोड",
    languageLabel: "भाषा",
    languageEnglish: "इंग्रजी",
    languageHindi: "हिंदी",
    heroEyebrow: "कारचे वय, स्पष्टपणे",
    heroTitle: "वाहनाचे वय पाहण्यासाठी एक स्वच्छ तारीख साधन.",
    heroDescription: "उत्पादन वर्ष निवडा. अधिक अचूक परिणाम हवा असेल तरच महिना जोडा.",
    yearSelectLabel: "उत्पादन वर्ष",
    monthSelectLabel: "उत्पादन महिना",
    includeMonthLabel: "अधिक अचूकतेसाठी विशिष्ट महिना समाविष्ट करा",
    includeMonthNote: "महिना समाविष्ट केला नाही तर गणनेसाठी जानेवारी वापरला जाईल.",
    yearOnlyBadge: "फक्त वर्ष",
    yearMonthBadge: "वर्ष + महिना",
    yearPlaceholder: "वर्ष निवडा",
    monthPlaceholder: "महिना निवडा",
    inputTitle: "उत्पादन वर्ष",
    inputLabel: "उत्पादन वर्ष",
    blockedDateNote: "भविष्यातील वर्षे निवडता येत नाहीत.",
    result: "परिणाम",
    vehicleAgeLead: "तुमचे वाहन",
    asOfToday: "आजच्या तारखेपर्यंत",
    years: "वर्षे",
    months: "महिने",
    days: "दिवस",
    totalDays: (count) => `एकूण ${count.toLocaleString("en-IN")} दिवस`,
    ageLabels: { almostNew: "जवळपास नवीन", modern: "आधुनिक", mature: "परिपक्व", classic: "क्लासिक" },
    estimatedValue: {
      high: "पुन्हा विक्रीची क्षमता जास्त",
      healthy: "मूल्य चांगले टिकते",
      moderate: "मध्यम घसरण",
      collector: "संग्राहकांची रुची वाढू शकते",
    },
    maintenanceTitle: "देखभाल",
    maintenance: {
      routine: "नियमित सर्विस आणि OEM देखभाल",
      watch: "ब्रेक, द्रव आणि टायरकडे लक्ष द्या",
      plan: "घासणाऱ्या भागांची आणि तपासणीची योजना करा",
      specialized: "विशेष देखभाल अधिक महत्त्वाची होते",
    },
    registrationTitle: "नोंदणी",
    registration: {
      collector: "काही भागांत संग्राहक-शैली सवलत लागू होऊ शकते",
      classic: "काही भागांत क्लासिक-कार नोंदणी लागू होऊ शकते",
      standard: "सामान्य नूतनीकरण आणि प्रादेशिक तपासणी अपेक्षित ठेवा",
      regular: "साधारणपणे नियमित नोंदणी लागू होते",
    },
    upcomingMilestoneTitle: "पुढील महत्त्वाचा टप्पा",
    milestoneTimelineTitle: "महत्त्वाच्या टप्प्यांची वेळरेषा",
    milestoneRemaining: ({ label, days }) => `${label} ${days.toLocaleString("mr-IN")} दिवसांत`,
    reached: "पूर्ण",
    upcoming: "लवकरच",
    allMilestonesReachedTitle: "दाखवलेले सर्व महत्त्वाचे टप्पे पूर्ण झाले आहेत",
    allMilestonesReachedBody: "या वाहनाने अॅपमध्ये दाखवलेली महत्त्वाच्या टप्प्यांची मर्यादा ओलांडली आहे.",
    copySummary: "सारांश कॉपी करा",
    shareResult: "परिणाम शेअर करा",
    resetMessage: "कॅल्क्युलेटर रीसेट झाला",
    summaryCopied: "सारांश क्लिपबोर्डमध्ये कॉपी झाला",
    clipboardFailed: "क्लिपबोर्डवर प्रवेश अयशस्वी",
    emptyTitle: "संपूर्ण तपशील पाहण्यासाठी उत्पादन वर्ष निवडा",
    emptyDescription:
      "वर्ष निवडल्यानंतर तुम्हाला अचूक वय, एकूण दिवस, देखभाल नोंदी, क्लासिक स्थिती आणि महत्त्वाच्या टप्प्यांची वेळ दिसेल.",
    shareTitle: "कार वय कॅल्क्युलेटर",
    summary: ({ label, years, months, days, asOf }) =>
      `माझी कार ${label} मध्ये तयार झाली होती आणि ${asOf} पर्यंत तिचे वय ${years} वर्षे ${months} महिने ${days} दिवस आहे.`,
    milestones: {
      1: { label: "पहिले वर्ष", note: "वॉरंटी आणि सर्व्हिस नियोजनासाठी उपयुक्त." },
      3: { label: "तीन वर्षे", note: "पुन्हा विक्री आणि मूल्य बदलासाठी सामान्य टप्पा." },
      5: { label: "पाच वर्षे", note: "देखभाल बजेट पुन्हा पाहण्यासाठी चांगला काळ." },
      10: { label: "दहा वर्षे", note: "जुने होत असलेल्या भागांकडे जास्त लक्ष द्या." },
      15: { label: "पंधरा वर्षे", note: "अनेक भागांत क्लासिक शैलीची हाताळणी सुरू होते." },
      25: { label: "पंचवीस वर्षे", note: "काही बाजारांत संग्राहक आणि आयातीसाठी आकर्षक." },
    },
  };
